const API_ROUTES = {
  CONTACT: '/web/api/contact',
  WIDGET_SCRIPT: '/widget/api/:token/script?language=:lang',
  PRODUCT_WIDGET_SCRIPT: '/widget/api/:token/script?product=:productId&language=:lang',
  GEO_IP: '/api/geoip', // internal route
  LATEST_REVIEWS: '/web/api/review/latest',
  ACCOUNTS: '/web/api/account/list',
  LIST_SERVICE_ACCOUNTS: '/web/api/account/list_service',
  ACCOUNTS_SEARCH: '/web/api/account/search',
  SINGLE_ACCOUNT: '/web/api/account/:slug',
  REVIEW: '/web/api/account/:id/review',
  ONE_REVIEW: '/web/api/review/:id/show',
  TRENDS: '/web/api/account/:id/review/trends',
  CATEGORIES: '/web/api/categories/:language',
  CATEGORY_ACCOUNT: '/web/api/category/accounts?slug=:slug&subtype=:type&language=:lang',
  PRODUCTS: '/web/api/account/:id/products/selected',
  REVIEW_HELPFUL: '/web/api/review/:id/helpful',
  REVIEW_UNHELPFUL: '/web/api/review/:id/unhelpful',
  PRODUCT_REVIEW_HELPFUL: '/web/api/product/review/:publicIdentifier/helpful',
  PRODUCT_REVIEW_UNHELPFUL: '/web/api/product/review/:publicIdentifier/unhelpful',
  COMPANY_MEDIA: '/web/api/account/:accountId/review/media',
  CATEGORY_COUNTRIES: '/web/api/location/countries',
  CATEGORY_REGIONS: '/web/api/location/:country/regions',
  CATEGORY_CITIES: '/web/api/location/:country/:region/cities',
  CATEGORY_ACCOUNT_CITY: '/web/api/location/:country/:region/:city',
  CATEGORY: '/web/api/category/:language/:slug',
  PRODUCT: '/web/api/account/:slug/product/:productId',
  PRODUCT_REVIEWS: '/web/api/account/:uuid/product/:productId/reviews',
  SLUG_TO_UUID: '/web/api/account/slug-to-uuid/:slug',
  PRODUCT_WIDGET: '/web/api/account/:uuid/vhydra',
  FAQ: '/web/api/account/:slug/faq',
  PRODUCTS_REVIEWS: '/web/api/account/:uuid/product-reviews',
  ACCOUNT_GROUP: '/web/api/account/:slug/group',
};

export default API_ROUTES;
